import { useUpdateSubscriptionTaxRegimeMutation } from './api'

export const useUpdateSubscriptionTaxRegime = () => {
    const [updateSubscriptionTaxRegime] = useUpdateSubscriptionTaxRegimeMutation()

    return {
        updateSubscriptionTaxRegime,
    }
}
